export const getGlucoState = (gluco) => {
    let glucoState = {}
    if(gluco >= 70 && gluco < 180){
        glucoState.color = "#00B050";
        glucoState.text = "정상";
    }else if(gluco >= 54 && gluco < 70){
        glucoState.color = "#FF0000";
        glucoState.text = "낮음";
    }else if(gluco >= 180 && gluco < 250){
        glucoState.color = "#FFE150";
        glucoState.text = "높음";
    }else if(gluco < 54){
        glucoState.color = "#860000";
        glucoState.text = "매우 낮음";
    }else if(gluco >= 250){
        glucoState.color = "#FFA90D";
        glucoState.text = "매우 높음";
    }
    return glucoState;
}    